/**
 * 
 */

let timer;

// newstickerの設定用オブジェクト
let ticker = {
	// li要素の数(リスト数)
	totalList: 0,
	// 現在のリスト番号
	numList: 0,
	// アニメーションの秒数
	time: 1000,
	// setInterval()の間隔
	interval: 5000
};
function showNews(){
    
    // リストの順番を決める
    ticker.numList ++;
    if (ticker.numList > ticker.totalList - 1){
        ticker.numList = 0;
    }

    var str = $('#newsUl li').eq(ticker.numList).html(); // a要素を取得

    // 上から下
	$("#whatsNewsTicker p").animate({top: ticker.height}, ticker.time, 'linear', function(){
		$('#whatsNewsTicker').html(str);
		$('#whatsNewsTicker p').css('top', '-' + ticker.height).animate({top: '0'}, ticker.time, 'linear');
	});
}
	
$(function() {

    ticker.totalList = $('#newsUl li').length;  // リスト数
    
    ticker.width = $('.pg-p-whats-news__box').css('width');    // 横幅
    ticker.height = $('.pg-p-whats-news__box').css('height');  // 長さ
    
    let str = $('#newsUl li:first').html();   // a要素

    $('#whatsNewsTicker').html(str);
    
    setInterval(showNews, ticker.interval);
    
});